import React from 'react';
import SearchField from 'src/components/SearchField';
import SearchSelect from 'src/components/SearchSelect';
import { IPaginationParams } from 'src/models/interfaces/pagination';
import { VehicleStatusTypeText } from 'src/types/IVehicle';
import { Container } from './styles';

interface IProps {
  params: IPaginationParams;
  mergeParams: (newParams: Partial<IPaginationParams>) => void;
}

const Filters = ({ params, mergeParams }: IProps) => {
  return (
    <Container>
      <SearchField
        placeholder='Digite ao menos 3 caracteres...'
        label='Pesquisar'
        width='250px'
        paginationParams={params}
        onChange={mergeParams}
      />
      <SearchSelect
        field='status'
        label='Status'
        onChange={mergeParams}
        options={Object.entries(VehicleStatusTypeText).map(([key, value]) => {
          return { label: value, value: key };
        })}
      />
    </Container>
  );
};

export default Filters;
